<template>
  <label class="mobile-filter-checkbox"><input type="checkbox" :checked="checkbox_state" @change="$emit('_emit_method_checkbox', [$event.target.checked, checkbox_key])"><span>{{ label_name }}</span></label>
</template>
<script>
export default {
  inheritAttrs: false,
  props: { checkbox_state: Boolean, checkbox_key: String, label_name: String }
};
</script>
<style scoped>
.mobile-filter-checkbox { display: flex; align-items: center; gap: 12px; min-height: 48px; font-size: 14px; border-bottom: 1px solid #8883; cursor: pointer; }
input { width: 18px; height: 18px; margin: 0; accent-color: #008aa9; }
</style>
